/* eslint-disable */
import request from '@/utils/request';
const isProduction = !window.location.host.includes('test') && !window.location.port.includes('8080');
const host = isProduction
? 'https://dinghw2.51x-study.com'
: 'https://dinghw2.test.51x-study.com'; // 测试环境

const BASE_URL = `${host}/mtapi/api`;

const login = (data) => request({
  url: `${BASE_URL}/login`,
  method: 'post',
  data,
});

const nextStep = (data) => request({
  url: `${BASE_URL}/go`,
  method: 'post',
  data,
});

const submitQues = (data) => request({
  url: `${BASE_URL}/submitQuestion`,
  method: 'post',
  data,
});

const sheet = (data) => request({
  url: `${BASE_URL}/sheet`,
  method: 'post',
  data,
});
const finishTransPage = (data) => request({
  url: `${BASE_URL}/finishTransPage`,
  method: 'post',
  data,
});
const applyLessonTime = (data) => request({
  url: `${BASE_URL}/mphy/flow/applyStudyTime`,
  method: 'post',
  data,
});
// mt答题记录页
const getMtAllQuestion = (data) => request({
  url: `${BASE_URL}/report/getQuestionList`,
  method: 'post',
  data,
});
//  文科答题详情页模块
const getUserAnswerQuesList = data => {
  return request({
    url: `${BASE_URL}/report/getUserAnswerQuesList`,
    method: 'post',
    data,
  });
};
//  自选答题详情-文科
const getQuestionSelfArts = (data) => request({
  url: `${BASE_URL}/report/getQuesAnswerInfo`,
  method: 'post',
  data,
});
export {
  login,
  nextStep,
  submitQues,
  sheet,
  finishTransPage,
  applyLessonTime,
  getMtAllQuestion,
  getUserAnswerQuesList,
  getQuestionSelfArts
};
